import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'my_account.report_a_bug',
  },
  report_title: {
    id: 'report_a_bug_modal.report_title',
  },
  object: {
    id: 'report_a_bug_modal.object',
  },
  message: {
    id: 'report_a_bug_modal.message',
  },
  requiredField: {
    id: 'required.field',
  },
  cancel: {
    id: 'addContract.cancel',
  },
  send: {
    id: 'report_a_bug_modal.send',
  },
  reportPasswordError: {
    id: 'Settings.password.Error',
  },
  reportAMC: {
    id: 'Settings.SignalerBug.Objet.AMC',
  },
  reportASI: {
    id: 'Settings.SignalerBug.Objet.ASI',
  },
  reportAUTO: {
    id: 'Settings.SignalerBug.Objet.Auto',
  },
  reportConexion: {
    id: 'Settings.SignalerBug.Objet.Connexion',
  },
  reportGeneral: {
    id: 'Settings.SignalerBug.Objet.General',
  },
  reportMRH: {
    id: 'Settings.SignalerBug.Objet.MRH',
  },
  reportNotif: {
    id: 'Settings.SignalerBug.Objet.Notif',
  },
  reportQR: {
    id: 'Settings.SignalerBug.Objet.QR',
  },
  epargn: {
    id: 'Settings.SignalerBug.Objet.Epargn',
  },
});
